import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import images from "../../../../utilities/images/images";
import QuestionWisePage from "../QuestionWisePage/QuestionWisePage";
import "./ViewSolution.css";

export default function ViewSolution() {
  const history = useHistory();
  const location = useLocation();
  const routeState = location?.state || {};
  const paperType = Number(routeState?.paperType || routeState?.paper_type);
  const isAdaptiveQBank =
    routeState?.isAdaptiveQBank === true || paperType === 20;
  const adaptiveSolutionParams = {
    paper_id: routeState?.paperId || routeState?.paper_id,
    paper_type: paperType || 20,
  };
  const handleBack = () => {
    if (isAdaptiveQBank) {
      const adaptiveId =
        routeState?.adaptive_question_id ||
        routeState?.adaptiveQuestionId ||
        routeState?.paperId ||
        routeState?.paper_id;
      const paperTypeBack =
        routeState?.paperType || routeState?.paper_type || paperType || 20;

      history.push({
        pathname: "/practice/adaptive-question-bank/submit",
        state: {
          adaptive_question_id: adaptiveId,
          paper_type: paperTypeBack,
          paperId: adaptiveId,
          topic: routeState?.topic || null,
          topic_id: routeState?.topic_id,
          topic_name: routeState?.topic_name,
          focusSetNo: routeState?.focusSetNo,
        },
      });
      return;
    }
    history.push("/practice-summary");
  };

  return (
    <div>
      <div className="view_solution_header">
        <button
          className="view_solution_back_btn"
          onClick={handleBack}
        >
          <img src={images.new_backarrow} alt="back" />
        </button>

        <h2 className="view_solution_title">View Solution</h2>
      </div>
      <QuestionWisePage
        showQuestionGrid={isAdaptiveQBank}
        showBottomAnalytics={false}
        isAdaptiveSolution={isAdaptiveQBank}
        adaptiveSolutionParams={isAdaptiveQBank ? adaptiveSolutionParams : null}
      />
    </div>
  );
}